import { useMemo } from "react";

import { createGeneratedArtifactsExtractor } from "../chat.helpers";
import type { McpResourceLink } from "../chat.types";
import { useChat } from "../providers/chat-provider";

/**
 * Recreate the extractor when the session changes: `ChatProvider` is reused across
 * session switches, so a `[]` memo would keep the previous session's settled cache.
 * Do not memo on `messages` array identity — it changes every stream throttle tick.
 */
export const useGeneratedArtifacts = (): McpResourceLink[] => {
  const { chatSession, messages } = useChat();
  const extract = useMemo(createGeneratedArtifactsExtractor, [chatSession.id]);
  return extract(messages);
};
